const BADGES = [
    {
        id: "first_checkin",
        icon: "✅",
        title: "First Step",
        description: "Complete your very first check-in",
        rarity: "common",
        color: "#a0a0a0",
        bg: "rgba(160,160,160,0.1)",
        border: "rgba(160,160,160,0.3)",
        task: "Check in to any challenge for the first time",
        reward: { type: "Participation", title: "First Step" },
        check: (stats) => stats.totalCheckins >= 1,
    },
    {
        id: "streak_3",
        icon: "🔥",
        title: "On Fire",
        description: "Maintain a 3-day streak",
        rarity: "common",
        color: "#fb923c",
        bg: "rgba(251,146,60,0.1)",
        border: "rgba(251,146,60,0.3)",
        task: "Check in 3 days in a row on any challenge",
        reward: { type: "Streak", title: "3-Days Streak" },
        check: (stats) => stats.maxStreak >= 3,
    },
    {
        id: "streak_7",
        icon: "⚡",
        title: "Week Warrior",
        description: "Maintain a 7-day streak",
        rarity: "rare",
        color: "#60a5fa",
        bg: "rgba(59,130,246,0.1)",
        border: "rgba(59,130,246,0.3)",
        task: "Check in 7 days in a row on any challenge",
        reward: { type: "Streak", title: "7-Days Streak" },
        check: (stats) => stats.maxStreak >= 7,
    },
    {
        id: "first_win",
        icon: "🏆",
        title: "First Blood",
        description: "Win your first challenge",
        rarity: "rare",
        color: "#facc15",
        bg: "rgba(234,179,8,0.1)",
        border: "rgba(234,179,8,0.3)",
        task: "Be the top performer when a challenge ends",
        reward: { type: "Winner", title: "First Win" },
        check: (stats) => stats.winnerCount >= 1,
    },
    {
        id: "social_butterfly",
        icon: "🦋",
        title: "Social Butterfly",
        description: "Join 3 different challenges",
        rarity: "rare",
        color: "#c084fc",
        bg: "rgba(168,85,247,0.1)",
        border: "rgba(168,85,247,0.3)",
        task: "Join and participate in 3 different challenges",
        reward: { type: "Participation", title: "Social Butterfly" },
        check: (stats) => stats.totalChallenges >= 3,
    },
    {
        id: "creator",
        icon: "⚙️",
        title: "Challenge Creator",
        description: "Create your first challenge",
        rarity: "common",
        color: "#22c55e",
        bg: "rgba(34,197,94,0.1)",
        border: "rgba(34,197,94,0.3)",
        task: "Create a challenge and invite others",
        reward: { type: "Participation", title: "Challenge Creator" },
        check: (stats) => stats.createdChallenges >= 1,
    },
    {
        id: "streak_30",
        icon: "💎",
        title: "Diamond Hands",
        description: "Maintain a 30-day streak",
        rarity: "legendary",
        color: "#facc15",
        bg: "rgba(234,179,8,0.1)",
        border: "rgba(234,179,8,0.3)",
        task: "Check in 30 days in a row on any challenge",
        reward: { type: "Streak", title: "30-Days Streak" },
        check: (stats) => stats.maxStreak >= 30,
    },
    {
        id: "triple_winner",
        icon: "👑",
        title: "Triple Crown",
        description: "Win 3 challenges",
        rarity: "legendary",
        color: "#facc15",
        bg: "rgba(234,179,8,0.15)",
        border: "rgba(234,179,8,0.4)",
        task: "Win 3 separate challenges",
        reward: { type: "Winner", title: "Triple Crown" },
        check: (stats) => stats.winnerCount >= 3,
    },
    {
        id: "mythic_winner",
        icon: "✦",
        title: "Mythic Legend",
        description: "Win 5 challenges with a 10-day streak",
        rarity: "mythic",
        color: "#c084fc",
        bg: "rgba(168,85,247,0.15)",
        border: "rgba(168,85,247,0.4)",
        task: "Win 5 challenges and maintain a 10-day streak",
        reward: { type: "Winner", title: "Mythic Legend" },
        check: (stats) => stats.winnerCount >= 5 && stats.maxStreak >= 10,
    },
];

export default BADGES;